import React from 'react';
import { render } from 'react-dom';

import Space from './Space';
import './Shared/css/index.css';

const cryptoHomeNode = document.querySelector('.crypto-home__app');

if (cryptoHomeNode) {
  const props = JSON.parse(cryptoHomeNode.innerText);

  cryptoHomeNode.style.display = '';

  render(<Space {...props} />, cryptoHomeNode);
}



// WEBPACK FOOTER //
// ./src/index.js